import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot} from '@angular/router';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {HeaderDataService} from './header-data.service';

import {environment} from '../../../environments/environment';

@Injectable()
export class MenuResolveService implements Resolve<any> {

    constructor(private headerDataService: HeaderDataService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        // returns menu list from web service
        return this.headerDataService.getMenuItems(environment.menu_api_url);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/menu-resolve.service.ts